import { NgModule } from '@angular/core';
import { AuthModule, CartModule, ProductModule, UserTransitionalModule } from 'haba-core';
import { LoginRouteModule, LogoutModule } from 'haba-storefrontlib';
import { UserFeatureModule } from '../features/user/user-feature.module';
import {
  CartEmporixModule,
  CartVoucherEmporixModule,
  ProductEmporixModule,
  UserEmporixModule,
  CartEntryEmporixModule,
  SiteEmporixModule,
  CheckoutServiceEmporixModule,
  ShoppingListEmporixModule,
} from 'haba-emporix';

@NgModule({
  declarations: [],
  imports: [
    // Auth Core
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    // User Core,
    UserTransitionalModule,
    UserFeatureModule,
    // Product Core,
    ProductModule.forRoot(),
    ProductEmporixModule,
    // Cart Core,
    CartModule.forRoot(),
    CartEmporixModule,
    CartEntryEmporixModule,
    SiteEmporixModule,
    UserEmporixModule,
    CheckoutServiceEmporixModule,
    CartVoucherEmporixModule,
    ShoppingListEmporixModule,
  ],
})
export class SpartacusFeaturesModule {}
